import { useEffect, useState } from 'react';

export const useHandleResize = () => {
  const [size, setSize] = useState({
    width: globalThis.innerWidth,
    height: globalThis.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: globalThis.innerWidth, height: globalThis.innerHeight });
    };
    globalThis.addEventListener('orientationchange', handleResize);
    globalThis.addEventListener('resize', handleResize);

    return () => {
      globalThis.removeEventListener('resize', handleResize);
      globalThis.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return size;
};
